import React, {useEffect, useState} from 'react';
import './RollingCredits.css';
import {Box, Typography} from "@mui/material";
import {useStore} from "../../stores/Store";
import {observer} from "mobx-react";
import RollingCreditsDialog from "./RollingCreditsDialog/RollingCreditsDialog";

export default observer(() => {
    const { CreditTextsStore, LanguageStore, SettingsStore  } = useStore();
    const [animationDuration, setAnimationDuration] = useState<string>('30s');

    useEffect(() => {
        const speedSetting = SettingsStore.findByName(`creditTextSpeed${LanguageStore.currentLanguage}`)
        if(parseInt(speedSetting.value) > 0) {
            setAnimationDuration(`${speedSetting.value}s`)
        }
    }, [LanguageStore.currentLanguage, CreditTextsStore.creditTexts, SettingsStore.settings]);

    return (
        <Box sx={{display: 'flex'}}>
            <Box className="credits-container">
                <Box className="credits-text" style={{ animationDuration: animationDuration }}>
                    <Typography fontSize={18}>{CreditTextsStore.toString(LanguageStore.currentLanguage)} </Typography>
                </Box>
            </Box>
            <Box>
                <RollingCreditsDialog />
            </Box>
        </Box>
    );
});
